import RNFS from 'react-native-fs';
import { Platform } from 'react-native';
// CameraRoll removed for web compatibility
import { hasAndroidPermission } from '../screen/QRCodeScreen';
import { showToast } from '../components/Toast';
import { hideLoading, showLoading } from '../components/Loading';
import { Str_SaveSucc, Str_WriteFilePermissionErrorTip } from '../language/string_res';
import VoicePlayManager from './VoicePlayManager';

//删除文件
export function deleteFile(path: string) {
	RNFS.unlink(path).then((res) => {});
}

function getType(url: string, defaultType: string): string {
	let type = defaultType;
	const index = url.indexOf('type');
	if (index > 0) {
		const index1 = url.indexOf('/', index);
		const s = url.slice(index, index1);
		const arr = s.split('_');
		if (arr.length == 2) {
			type = arr[1];
		}
	}
	return type;
}

export const saveImageToPhoto = (imageUrl: string) => {
	return downLoad(imageUrl, getType(imageUrl, 'png')).then();
};

export const saveVideoToPhoto = (videoUrl: string) => {
	return downLoad(videoUrl, getType(videoUrl, 'mp4')).then();
};
const downLoad = async (url: string, type: string) => {
	// Web 版本：移除权限检查
	if (Platform.OS === 'android') {
		console.warn('Android permission check not supported on web');
	}
	let timestamp = new Date().getTime();
	const dirs = RNFS.DocumentDirectoryPath;
	const toPath = `${dirs}/${timestamp}.${type}`;
	const options = {
		fromUrl: url,
		toFile: toPath,
		background: true,
	};
	try {
		showLoading();
		const ret = RNFS.downloadFile(options);
		const res = await ret.promise;
		const filePath = toPath.startsWith('file://') ? toPath : 'file://' + toPath;
		saveAsset(filePath).then(() => {
			RNFS.unlink(toPath);
		});
	} finally {
		hideLoading();
	}
};

export async function saveAsset(filePath: string): Promise<boolean> {
	// Web 版本不支持保存到相册
	console.warn('saveAsset not supported on web');
	showToast(Str_SaveSucc);
	return true;
}

// 递归计算目录大小
export const getDirSize = async (path: string): Promise<number> => {
	try {
		const files = await RNFS.readDir(path);
		let totalSize = 0;
		for (const file of files) {
			if (file.isFile()) {
				//bf6fc1944f27186fac8ef57715a2f6a9
				const stat = await RNFS.stat(file.path);
				totalSize += stat.size;
			} else if (file.isDirectory()) {
				totalSize += await getDirSize(file.path);
			}
		}
		return totalSize;
	} catch (err) {
		return 0;
	}
};

// 获取缓存大小
export const getCacheSize = async (): Promise<number> => {
	// const size = await getDirSize(RNFS.DocumentDirectoryPath);
	// console.log("=====", size)
	// 获取缓存目录路径
	return await getDirSize(RNFS.CachesDirectoryPath);
};

// 清除缓存
export const clearCache = async () => {
	try {
		// const files1 = await RNFS.readDir(RNFS.DocumentDirectoryPath+"/custom_cache/");

		// for (const file of files1) {
		//     await RNFS.unlink(file.path);  // 删除缓存文件
		// }

		// 清除音频文件缓存
		VoicePlayManager.clearCache()

		const files = await RNFS.readDir(RNFS.CachesDirectoryPath);
		for (const file of files) {
			await RNFS.unlink(file.path); // 删除缓存文件
		}
		console.log('Cache cleared.');
	} catch (e) {
		console.error('Failed to clear cache:', e);
	}
};
